import { render, staticRenderFns } from "./queryPsDrawBillAction.vue?vue&type=template&id=23907612&scoped=true"
import script from "./queryPsDrawBillAction.vue?vue&type=script&lang=js"
export * from "./queryPsDrawBillAction.vue?vue&type=script&lang=js"
import style0 from "./queryPsDrawBillAction.vue?vue&type=style&index=0&id=23907612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23907612",
  null
  
)

export default component.exports